var arabam;
(function (arabam) {
    var LastSearchItem = /** @class */ (function () {
        function LastSearchItem() {
            var self = this;
            self.titles = [];
            self.filters = [];
            self.selectedFilters = [];
            self.selectedCategoryFilters = [];
            self.timeStamp = 0;
            self.count = "0";
            self.url = "";
        }
        return LastSearchItem;
    }());
    arabam.LastSearchItem = LastSearchItem;
    var LastSearchService = /** @class */ (function () {
        function LastSearchService($rootScope, $window) {
            this.$rootScope = $rootScope;
            this.$window = $window;
            this.currentSessionId = "";
            this.searches = [];
        }
        /**
         * algoritma
         * tarayici uygun mu (localstorage destekliyor mu)
         * uygunsa session kontrol et
         * mevcut session degeri varsa dokunma, yoksa yarat (session degeri tarayici kapatildiginda sifirlanir)
         * arama kaydedilecegi zaman mevcut session bilgisini de ekle
         * bu session bilgisine gore filtreleme / gosterme / gizleme logicleri directive'in sorumlulugu (lastSearches.ts)
         */
        LastSearchService.prototype.init = function () {
            var self = this;
            if (self.isBrowserCompatible()) {
                self.prepareSession();
                self.readLocalStorage();
            }
            return self.isBrowserCompatible();
        };
        LastSearchService.prototype.prepareSession = function () {
            try {
                var currentSessionValue = sessionStorage.getItem("currentSessionValue");
                if (!currentSessionValue) {
                    this.currentSessionId = this.createGUID();
                    sessionStorage.setItem("currentSessionValue", this.currentSessionId);
                }
                else {
                    this.currentSessionId = currentSessionValue;
                }
            }
            catch (error) {
                console.warn(error);
            }
        };
        LastSearchService.prototype.saveSearch = function (selectedFilters, url, categories, totalCount) {
            if (categories === void 0) { categories = []; }
            var self = this;
            //console.debug(selectedFilters, categories);
            if (self.shouldBeSaved(selectedFilters, categories)) {
                var item = self.prepareSearchItem(selectedFilters, categories);
                item.url = url;
                item.selectedCategoryFilters = categories;
                item.count = totalCount;
                item.sessionId = self.currentSessionId;
                if (self.shouldCreateNew(categories)) {
                    //console.debug("should create new");
                    self.searches.unshift(item);
                }
                else {
                    //console.debug("should NOT create new");
                    self.searches[0] = item;
                }
                self.searches.splice(2);
                // ayni sessiondan iki kayit atma
                if (self.searches[0] &&
                    self.searches[1] &&
                    self.searches[0].sessionId == self.searches[1].sessionId) {
                    //console.debug("aynı sesionda iki tane");
                    self.searches.splice(1);
                }
                self.writeLocalStorage();
                return true;
            }
            else {
                return false;
            }
        };
        /**
         * işleme alınıp alınmayacağı burada filtrelenecek
         * @param selectedFilters
         */
        LastSearchService.prototype.shouldBeSaved = function (selectedFilters, categories) {
            var self = this;
            if (!self.isBrowserCompatible()) {
                return false;
            }
            /*let categoryFacetExistsIndex = self.categoryFacetsExists(categories);
                  if (categoryFacetExistsIndex > 0) {
                      //ui'dan bir son aramaya tiklanmissa onu basa al
                      self.searches.splice(0, 0, self.searches.splice(categoryFacetExistsIndex, 1)[0]);
                      self.writeLocalStorage();
                      return false;
                  }*/
            var selectedFiltersThatMatter = selectedFilters.filter(function (filter) {
                return (filter.PropertyName != "view" &&
                    filter.PropertyName != "currency" &&
                    filter.PropertyName != "page");
            });
            if (selectedFiltersThatMatter.length > 0) {
                return true;
            }
            else {
                return false;
            }
        };
        /**
         * yeni bir searchitem mı yaratılmalı
         * @param selectedFilters
         */
        LastSearchService.prototype.shouldCreateNew = function (categories) {
            var self = this;
            var lastSearch = self.searches[0];
            if (!lastSearch) {
                return true;
            }
            var lastSearchCategoryFilters = lastSearch.selectedCategoryFilters;
            var lastSessionId = lastSearch.sessionId;
            var newSearchCategoryFilters = categories;
            var newSessionId = self.currentSessionId;
            /*let categoriesCompatible = self.categoryFacetsAreCompatible(lastSearchCategoryFilters, newSearchCategoryFilters);
      
                  if (newSearchCategoryFilters.length != lastSearchCategoryFilters.length && lastSearchCategoryFilters.length == 0) {
                      console.log('0a eklenmiş, guncelle')
                      return false;
                  }
                  if (newSearchCategoryFilters.length != lastSearchCategoryFilters.length) {
                      console.log('kategori sayisi degismis, yeni')
                      return true;
                  }
                  else if (categoriesCompatible) {
                      console.log('kategori compatible, güncelle')
                      return false;
                  }
                  else if (!categoriesCompatible) {
                      console.log('kategori comptabile değil, yeni')
                      return true;
                  }
                  else {
                      console.log('else, güncelle')
                      return false;
                  }*/
            return lastSessionId != newSessionId;
        };
        /**
         * selected filter içindeki tüm kategori facetlerini getir
         * @param selectedFilters
         */
        /*extractCategoryFacets(selectedFilters: any): any[] {
                let result: any[] = [];
                if (selectedFilters && selectedFilters.length > 0) {
                    selectedFilters.forEach((filter: any) => {
                        if (filter.PropertyName == "category") {
                            result.push(filter);
                        }
                    });
                }
                return result;
            }*/
        /**
         * ayni search isleminin devami mi
         * @param categoryFilters
         */
        /*categoryFacetsAreCompatible(oldCategoryFilters: any[], newCategoryFilters: any[]): boolean {
                let self = this;
                let countIsEqual: boolean = false;
                let categoriesAreCompatible: boolean = true;
    
                //kategori facet sayisi esit degilse yeni ekle
                countIsEqual = oldCategoryFilters.length == newCategoryFilters.length;
                if (!countIsEqual) {
                    return false;
                }
    
                //icindeki breadcrumblari karsilastir
                for (let index = 0; index < oldCategoryFilters.length; index++) {
                    let oldBreadCrumb: any[] = oldCategoryFilters[index];
                    let newBreadCrumb: any[] = newCategoryFilters[index];
    
    
                    if (oldBreadCrumb.length != newBreadCrumb.length && oldBreadCrumb.length - newBreadCrumb.length < 0) {
                        console.debug('mevcut facete yeni cat eklenmiş');
                        categoriesAreCompatible = self.compareBreadCrumbs(oldBreadCrumb, newBreadCrumb, 'left');
                    }
                    else if (oldBreadCrumb.length != newBreadCrumb.length && oldBreadCrumb.length - newBreadCrumb.length > 0) {
                        console.debug('mevcut facetten yeni cat cikarilmis');
                        categoriesAreCompatible = self.compareBreadCrumbs(oldBreadCrumb, newBreadCrumb, 'right');
                    }
                    else {
                        console.debug('sayi ayni');
                        categoriesAreCompatible = self.compareBreadCrumbs(oldBreadCrumb, newBreadCrumb, 'deep');
                    }
                }
    
                return countIsEqual && categoriesAreCompatible;
            }*7
    
            /**
             * breadcrumbları birbiriyle karşılaştırır
             * @param oldBreadCrumb
             * @param newBreadCrumb
             * @param direction
             */
        /*compareBreadCrumbs(oldBreadCrumb: any[], newBreadCrumb: any[], direction: any): boolean {
                let result: boolean = true;
                //direction left ise, old içindeki herşey newde varsa true dön
                if (direction == 'left') {
                    for (let index = 0; index < oldBreadCrumb.length; index++) {
                        let oldItem = oldBreadCrumb[index];
                        let newItem = newBreadCrumb[index];
    
                        if (oldItem.Id != newItem.Id) {
                            result = false;
                        }
                    }
                }
                else if (direction == 'right') {
                    for (let index = 0; index < newBreadCrumb.length; index++) {
                        let oldItem = oldBreadCrumb[index];
                        let newItem = newBreadCrumb[index];
    
                        if (oldItem) {
                            if (oldItem.Id != newItem.Id) {
                                result = false;
                            }
                        }
                        else {
                            if (newItem.ParentId != oldItem.Id) {
                                result = false;
                            }
                        }
                    }
                }
                else if (direction == 'deep') {
                    for (let index = 0; index < oldBreadCrumb.length; index++) {
                        let oldItem = oldBreadCrumb[index];
                        let newItem = newBreadCrumb[index];
    
                        if (oldItem.Id != newItem.Id) {
                            result = false;
                        }
                    }
                    result = result && oldBreadCrumb.length == newBreadCrumb.length;
                }
                return result;
            }*/
        LastSearchService.prototype.prepareSearchItem = function (selectedFilters, categories) {
            var self = this;
            var item = new LastSearchItem();
            var tempTitle = "";
            selectedFilters.forEach(function (filter) {
                switch (filter.PropertyName) {
                    case "town":
                        var tempTownName = filter.DisplayName.split("-").length > 1
                            ? filter.DisplayName.split("-")[1]
                            : filter.DisplayName;
                        tempTownName[0] = tempTownName[0].toUpperCase();
                        item.filters.push(tempTownName);
                        break;
                    case "city":
                    case "fuel":
                    case "tag":
                    case "damagestatus":
                    case "color":
                    case "photo":
                    case "gear":
                    case "membertype":
                    case "bodytype":
                    case "lifeStyle":
                        item.filters.push(filter.DisplayName);
                        break;
                    case "category":
                    case "view":
                    case "page":
                    case "currency":
                    case "wizardTag":
                        break;
                    default:
                        item.filters.push(filter.Name + ": " + filter.DisplayName);
                        break;
                }
            });
            item.filters = item.filters.filter(self.onlyUnique);
            categories.forEach(function (categoryList) {
                categoryList.forEach(function (category) {
                    if (categoryList.length == 1) {
                        tempTitle += " " + category.Name;
                    }
                    else if (category.Level > 1) {
                        tempTitle += " " + category.Name;
                    }
                });
                item.titles.push(tempTitle.trim());
                tempTitle = "";
            });
            item.selectedFilters = selectedFilters;
            item.timeStamp = Math.floor(Date.now());
            return item;
        };
        /**
         * bu arama, son aramalar içinde var mı?
         * @param categories
         */
        /*categoryFacetsExists(categories: any[]): number {
                let self = this;
                let equalIndex: number = -1;
    
                for (var index = 0; index < self.searches.length; index++) {
                    let lastSearch = self.searches[index];
    
                    let lastSearchCategoryFilters = lastSearch.selectedCategoryFilters;
                    let newSearchCategoryFilters = categories;
                    let categoriesEqual = self.categoryFacetsAreEqual(lastSearchCategoryFilters, newSearchCategoryFilters);
    
                    equalIndex = categoriesEqual ? index : equalIndex;
                }
    
                return equalIndex;
            }
    
            categoryFacetsAreEqual(oldCategoryFilters: any[], newCategoryFilters: any[]): boolean {
                let self = this;
                let countIsEqual: boolean = false;
                let categoriesAreCompatible: boolean = true;
    
                //kategori facet sayisi esit degilse reddet
                countIsEqual = oldCategoryFilters.length == newCategoryFilters.length;
                if (!countIsEqual) {
                    return false;
                }
    
                //icindeki breadcrumblari karsilastir
                for (let index = 0; index < oldCategoryFilters.length; index++) {
                    let oldBreadCrumb: any[] = oldCategoryFilters[index];
                    let newBreadCrumb: any[] = newCategoryFilters[index];
    
                    //breadcrumb icindeki kategori sayisi farkliysa reddet
                    if (oldBreadCrumb.length != newBreadCrumb.length) {
                        return false;
                    }
    
                    for (let index = 0; index < oldBreadCrumb.length; index++) {
                        let oldItem = oldBreadCrumb[index];
                        let newItem = newBreadCrumb[index];
    
                        if (oldItem.Id != newItem.Id) {
                            categoriesAreCompatible = categoriesAreCompatible && false;
                        }
                    }
                }
    
                return categoriesAreCompatible;
            }*/
        LastSearchService.prototype.onlyUnique = function (value, index, self) {
            return self.indexOf(value) === index;
        };
        /**
         * listeden aramayi sil
         */
        LastSearchService.prototype.remove = function (index) {
            var self = this;
            if (typeof index == "number") {
                self.searches.splice(index, 1);
                self.writeLocalStorage();
                return true;
            }
            else {
                return false;
            }
        };
        LastSearchService.prototype.removeItem = function (item) {
            var self = this;
            var found = -1;
            for (var index = 0; index < self.searches.length; index++) {
                var element = self.searches[index];
                if (element.timeStamp == item.timeStamp)
                    found = index;
            }
            if (found > -1) {
                self.searches.splice(found, 1);
                self.writeLocalStorage();
                return true;
            }
            else {
                return false;
            }
        };
        /**
         * son aramaları döner
         */
        LastSearchService.prototype.getSearches = function () {
            var self = this;
            return self.searches;
        };
        /**
         * session id doner
         */
        LastSearchService.prototype.getSessionId = function () {
            return this.currentSessionId;
        };
        /**
         * servisi temizler
         */
        LastSearchService.prototype.empty = function () {
            var self = this;
            self.searches = [];
            self.writeLocalStorage();
            return true;
        };
        /**
         * listeyi local storage'a yaz
         */
        LastSearchService.prototype.writeLocalStorage = function () {
            var self = this;
            try {
                localStorage.setItem("lastSearches", JSON.stringify(this.searches));
            }
            catch (e) {
                return false;
            }
            return true;
        };
        /**
         * local storage'dan listeyi oku
         */
        LastSearchService.prototype.readLocalStorage = function () {
            var self = this;
            try {
                var temp = localStorage.getItem("lastSearches");
                if (temp) {
                    self.searches = JSON.parse(temp);
                }
            }
            catch (e) {
                return false;
            }
            return true;
        };
        /**
         * storage tipi mevcut mu
         * @param type
         */
        LastSearchService.prototype.storageAvailable = function (type) {
            try {
                var storage = this.$window[type];
                var x = "__storage_test__";
                storage.setItem(x, x);
                storage.removeItem(x);
                return true;
            }
            catch (e) {
                return false;
            }
        };
        LastSearchService.prototype.isBrowserCompatible = function () {
            var self = this;
            var result = false;
            result = self.storageAvailable("localStorage");
            if (!result) {
                result = self.storageAvailable("sessionStorage");
            }
            return result;
        };
        LastSearchService.prototype.createGUID = function () {
            function S4() {
                return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            }
            // then to call it, plus stitch in '4' in the third group
            return (S4() +
                S4() +
                "-" +
                S4() +
                "-4" +
                S4().substr(0, 3) +
                "-" +
                S4() +
                "-" +
                S4() +
                S4() +
                S4()).toLowerCase();
        };
        LastSearchService.$inject = ["$rootScope", "$window"];
        return LastSearchService;
    }());
    arabam.LastSearchService = LastSearchService;
    angular.module("arabam").service("LastSearchService", LastSearchService);
})(arabam || (arabam = {}));
